module.exports = __webpack_public_path__ + "media/images/gaadaobat-4a8d98a3.svg";